import React, { Component } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";

import { ArrowLeft, ArrowRight } from "../components/Icons";

const styles = (theme) => ({
    wrapperStyle: {
        display: "flex",
        justifyContent: "space-between",
    },
    arrowButtonStyle: {
        color: "#303c49",
        borderRadius: "inherit",
        position: "absolute",
        top: 0,
        width: "16%",
        height: "100%",
    },
    arrowButtonStyleLeft: {
        left: 0,
    },
    arrowButtonStyleRight: {
        right: 0,
    },
    dotContainerStyle: {
        display: "flex",
        width: "calc(100% - 84px)",
        height: 40,
        justifyContent: "center",
        alignItems: "center",
    },
    dotButtonStyle: {
        width: 12,
        height: 12,
        border: "1px solid #d6d8db",
        borderRadius: "50%",
        marginLeft: 5,
        marginRight: 5,
    },
    dotButtonActiveStyle: {
        backgroundColor: "#e40045",
        border: "1px solid #e40045",
    },
    arrowButtonInnerStyle: {
        background: "rgba(255,255,255,0.8)",
        padding: 12,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

class SliderControls extends Component {
    onDecreaseIndex = () => {
        const { onChangeIndex, activeIndex, mediaAmount } = this.props;
        const newIndex = activeIndex - 1;
        onChangeIndex(newIndex < 0 ? mediaAmount - 1 : newIndex);
    };

    onIncreaseIndex = () => {
        const { onChangeIndex, activeIndex, mediaAmount } = this.props;
        const newIndex = activeIndex + 1;
        onChangeIndex(newIndex === mediaAmount ? 0 : newIndex);
    };

    render() {
        const {
            activeIndex,
            mediaAmount,
            onChangeIndex,
            classes: {
                wrapperStyle,
                arrowButtonStyle,
                dotContainerStyle,
                dotButtonStyle,
                dotButtonActiveStyle,
                arrowButtonStyleLeft,
                arrowButtonStyleRight,
                arrowButtonInnerStyle,
            },
        } = this.props;

        return (
            <div className={`${wrapperStyle} slider-controls-wrapper`}>
                <ButtonBase
                    classes={{ root: classNames(arrowButtonStyle, arrowButtonStyleLeft) }}
                    onClick={this.onDecreaseIndex}
                    disableRipple
                >
                    <div className={arrowButtonInnerStyle}>
                        <ArrowLeft size={16} />
                    </div>
                </ButtonBase>

                <div className={dotContainerStyle}>
                    {[...Array(mediaAmount)].map((_, index) => (
                        <div
                            key={index}
                            className={classNames(dotButtonStyle, index === activeIndex && dotButtonActiveStyle)}
                            onClick={() => onChangeIndex(index)}
                        />
                    ))}
                </div>

                <ButtonBase
                    classes={{ root: classNames(arrowButtonStyle, arrowButtonStyleRight) }}
                    onClick={this.onIncreaseIndex}
                    disableRipple
                >
                    <div className={arrowButtonInnerStyle}>
                        <ArrowRight size={16} />
                    </div>
                </ButtonBase>
            </div>
        );
    }
}

export default withStyles(styles)(SliderControls);



// WEBPACK FOOTER //
// ./src/emobility/EMobilitySliderControls.js